import { Flex, Icon, Typography } from '@aloft/toolkit-sui';

export const Fallback = ({ fallbackText = 'Image not found' }: { fallbackText?: string }) => (
  <Flex flexDirection="column" alignItems="center" justifyContent="center" height="100%">
    <Icon icon="home-2" size="xxl" color="strokeActive" />
    <Typography variant="placeholder">{fallbackText}</Typography>
  </Flex>
);
